import React from 'react';
import { motion } from 'framer-motion';
export function VisionSection() {
  return <section className="py-24 bg-gym-dark relative overflow-hidden" data-id="element-337">
      {/* Decorative background elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gym-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-338"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-339">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-340">
          <h2 className="text-4xl md:text-6xl font-bold mb-12 uppercase tracking-wide text-gym-gold" data-id="element-341">
            Imagina esto por un momento
          </h2>

          <div className="space-y-8 text-xl md:text-2xl text-gray-200 leading-relaxed font-body italic" data-id="element-342">
            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-343">
              Imagina levantarte un martes por la mañana y sentirte con energía
              real.
              <br data-id="element-344" />
              <span className="text-gray-400 text-lg md:text-xl" data-id="element-345">
                No la energía del café. La energía de un cuerpo que está
                funcionando bien.
              </span>
            </motion.p>

            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-346">
              Imagina ponerte esa ropa que llevas meses sin usar porque "no te
              queda bien"
              <br data-id="element-347" />
              <span className="text-gym-green font-bold not-italic" data-id="element-348">
                — y que te quede perfecta.
              </span>
            </motion.p>

            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.6
          }} data-id="element-349">
              Imagina llegar a la playa, a una reunión, a una foto familiar
              <br data-id="element-350" />
              <span className="text-white font-bold not-italic uppercase text-3xl md:text-4xl block mt-4" data-id="element-351">
                y sentirte orgulloso de cómo te ves.
              </span>
            </motion.p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.8
        }} className="mt-16" data-id="element-352">
            <p className="text-xl text-gray-400" data-id="element-353">No es un sueño lejano.</p>
            <p className="text-2xl font-bold text-white mt-2" data-id="element-354">
              Es lo que pasa cuando finalmente tienes el sistema correcto
              trabajando para ti.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}